import React, { Component, Fragment } from 'react'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import {
    Edit,
    TextInput,
    SelectInput,
    showNotification
} from 'react-admin'
import Title from '../Generic/Title'
import { CustomSimpleForm } from '../Generic'

import { rolesChoices, booleanChoice } from './data.js'
import ButtonsEditToolbar from './ButtonsEditToolbar'


class UsuarioEditClass extends Component {
  render () {
    const { permissions } = this.props
    if (permissions === null) {
        return null
    }
    const role = permissions.role
    return (
      <Fragment>
        <Title title={"Editar Usuario Coordinador"} />
        <Edit {...this.props}>
          <CustomSimpleForm toolbar={<ButtonsEditToolbar { ...this.props }/>}>
            <TextInput source="username" disabled={role === "coordinado"} label="Nombre de Usuario"/>
            <TextInput source="email" />
            <TextInput source="first_name" label="Nombre" />
            <TextInput source="last_name" label="Apellido" />
            { role === "coordinado"
              ? null
              : (
                  <SelectInput
                    source="role"
                    choices={rolesChoices}
                  />
              )
            }

            { role === "coordinado"
              ? null
              : (
                  <SelectInput
                    disabled={role === "coordinado"}
                    label="Estado del usuario"
                    source="is_active"
                    choices={booleanChoice}
                  />
              )
            }
          </CustomSimpleForm>
        </Edit>
      </Fragment>
    )
  }
};

const enhance = compose(
    connect( null, { showNotification }),
    reduxForm({
        form: 'redux-form'
    })
)

export const UsuarioEdit = enhance(UsuarioEditClass)
